import { render, staticRenderFns } from "./PublisherDetails.vue?vue&type=template&id=628fef3a"
import script from "./PublisherDetails.vue?vue&type=script&lang=js"
export * from "./PublisherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports